import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import { useState } from 'react';
import HotelHitLink from './HotelHitLink.js';
import { HotelHitImageContent as HotelHitImageContent$2, OpenGalleryLink, ConceptInfo, CloseButton } from './styles/hotelHitImageContent.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import Icon from '../../Icon/Icon.js';
import { DOCUMENT_MEDIA_PHOTO } from '../../IconPath/DOCUMENT_MEDIA_PHOTO.js';
import ConceptBadge from '../../ConceptBadge/ConceptBadge.js';
import Tags from '../../Tags/Tags.js';
import { USER_INTERFACE_CROSS_CANCEL } from '../../IconPath/USER_INTERFACE_CROSS_CANCEL.js';
import { USER_INTERFACE_TICK_DONE } from '../../IconPath/USER_INTERFACE_TICK_DONE.js';

var HotelHitImageContent = function HotelHitImageContent(_ref) {
  var concept = _ref.concept,
    tags = _ref.tags,
    lolloAndBernie = _ref.lolloAndBernie,
    href = _ref.href,
    onSelect = _ref.onSelect,
    onOpenGallery = _ref.onOpenGallery,
    showGallery = _ref.showGallery,
    isMapsView = _ref.isMapsView,
    siteId = _ref.siteId,
    lazy = _ref.lazy;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showConceptInfo = _useState2[0],
    setShowConceptInfo = _useState2[1];
  return /*#__PURE__*/jsxs(HotelHitImageContent$2, {
    concept: concept,
    children: [!onOpenGallery && (href || onSelect) && /*#__PURE__*/jsx(HotelHitLink, {
      href: href,
      onSelect: onSelect
    }), onOpenGallery && /*#__PURE__*/jsxs(OpenGalleryLink, {
      onClick: onOpenGallery,
      children: [/*#__PURE__*/jsx(Icon, {
        className: "sg-open-gallery-icon",
        path: DOCUMENT_MEDIA_PHOTO,
        size: "m"
      }), /*#__PURE__*/jsx("span", {
        children: showGallery
      })]
    }), concept && /*#__PURE__*/jsx(ConceptBadge, {
      className: "sg-hotel-hit__concept-badge",
      concept: concept.name,
      onClick: function onClick() {
        return setShowConceptInfo(!showConceptInfo);
      },
      siteId: siteId,
      lazy: lazy
    }), showConceptInfo && !isMapsView && concept && concept.usp && concept.usp.list && concept.usp.list.length > 0 && /*#__PURE__*/jsxs(ConceptInfo, {
      children: [/*#__PURE__*/jsx(CloseButton, {
        onClick: function onClick() {
          return setShowConceptInfo(false);
        },
        type: "button",
        children: /*#__PURE__*/jsx(Icon, {
          path: USER_INTERFACE_CROSS_CANCEL
        })
      }), concept.usp.header && /*#__PURE__*/jsx("h3", {
        children: concept.usp.header
      }), /*#__PURE__*/jsx("ul", {
        children: concept.usp.list.map(function (item) {
          return /*#__PURE__*/jsxs("li", {
            children: [/*#__PURE__*/jsx(Icon, {
              className: "sg-concept-info-icon",
              path: USER_INTERFACE_TICK_DONE,
              size: "s"
            }), /*#__PURE__*/jsx("span", {
              children: item
            })]
          }, item);
        })
      })]
    }), tags && tags.length > 0 ? /*#__PURE__*/jsx(Tags, {
      className: "sg-hotel-hit__tags",
      tags: tags,
      responsive: true
    }) : null, lolloAndBernie && lolloAndBernie.imageUrl && /*#__PURE__*/jsx("img", {
      src: lolloAndBernie.imageUrl,
      alt: lolloAndBernie.name || '',
      className: "sg-hotel-hit__lollo-and-bernie",
      loading: lazy ? 'lazy' : 'eager'
    })]
  });
};
HotelHitImageContent.defaultProps = {
  concept: null,
  tags: null,
  lolloAndBernie: null,
  onSelect: null,
  onOpenGallery: null,
  showGallery: '',
  href: null,
  isMapsView: false,
  siteId: 1,
  lazy: false
};
var HotelHitImageContent$1 = HotelHitImageContent;

export { HotelHitImageContent$1 as default };
//# sourceMappingURL=HotelHitImageContent.js.map
